<template>
  <div>
    <Head title="Dispatch Receipts" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" :href="`/dispatches`">Picked Orders</Link>
        <span class="text-orange-400 font-medium">/</span>{{ picklist.pick_list_no }}/Receipts
    </h1>
    <div class="bg-white rounded-md shadow mb-5">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-2 -mr-6 pt-8 pl-8 pr-8 pb-8">
          <div class="pb-2 pr-6 mb-3 w-full lg:w-full">
            <Checkbox label="Cushions/Timber" :active="cushion" @input="cushion = $event"/>
          </div>
          <div class="w-1/3 lg:w-1/2 pb-2 pr-6">
            <multiselect
              id="location"
              v-model="selectedLocation"
              placeholder="Search Locations"
              :options="locations"
              :close-on-select="true"
              :searchable="true"
              :error="form.errors.location_id"
              :style="form.errors.location_id ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
              @search-change="onSearchLocationChange"
              @input="onSelectedLocation"
            />
            <div v-if="form.errors.location_id" class="form-error">{{ form.errors.location_id }}</div>
          </div>
          <div v-show="cushion" class="w-1/3 lg:w-1/4">
            <text-input
              v-model="form.quantity"
              :error="form.errors.quantity"
              class="pb-2 pr-6 w-full lg:w-full"
              placeholder="Quantity"
            />
          </div>
          <div v-show="cushion" class="w-1/3 lg:w-1/4">
            <text-input
              v-model="form.part_number"
              :error="form.errors.part_number"
              class="pb-2 pr-6 w-full lg:w-full"
              placeholder="Scan Part Number"
            />
          </div>
          <div v-show="!cushion" class="w-1/3 lg:w-1/2">
            <text-input
              v-model="form.item_id"
              :error="form.errors.item_id"
              class="pb-2 pr-6 w-full lg:w-full"
              placeholder="Scan UID"
            />
          </div>
        </div>
        <div
          class="flex items-center justify-end w-full px-8 py-4 bg-gray-50 border-t border-gray-100"
        >
          <loading-button
            :loading="form.processing"
            class="btn-orange px-3 py-2 text-xs"
            type="submit"
          >
            Add Receipts
          </loading-button>
        </div>
      </form>
    </div>
    <div class="flex items-center justify-between mb-6 mt-6 hidden">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset" />
      <Link class="btn-orange" href="">
        <span>Add</span>
        <span class="hidden md:inline">&nbsp;Receipt</span>
      </Link>
    </div>
    <hr />
    <ul
      id="tabs-tabFill"
      class="nav nav-tabs flex flex-col md:flex-row flex-wrap list-none border-b-0 pl-0 mb-4"
      role="tablist"
    >
      <li class="nav-item flex-auto text-center" role="presentation">
        <a
          id="tabs-home-tabFill"
          href="#tabs-homeFill"
          class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent
          active" 
          data-bs-toggle="pill" 
          data-bs-target="#tabs-homeFill" 
          role="tab"
          aria-controls="tabs-homeFill"
          aria-selected="true"
        >
          Scans
        </a>
      </li>
      <li
        class="nav-item flex-auto text-center"
        role="presentation"
      >
        <a
          id="tabs-summary-tabFill"
          href="#tabs-summaryFill"
          class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent"
          data-bs-toggle="pill"
          data-bs-target="#tabs-summaryFill"
          role="tab"
          aria-controls="tabs-summaryFill"
          aria-selected="false"
        >
          Summaries
        </a>
      </li>
    </ul>
    <div id="tabs-tabContentFill" class="tab-content">
      <div id="tabs-homeFill" class="tab-pane fade show active" role="tabpanel" aria-labelledby="tabs-home-tabFill">
        <div class="flex items-center justify-between mb-6">
          <a
            v-if="today_receipts.data.length > 0"
            :href="`/dispatches/receipts/download/${urlScans()}`"
            class="btn-orange px-3 py-2 text-xs cursor-pointer"
            download
            target="__blank"
          >
            <span>Download</span>
          </a>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto mt-5">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-3 pt-3 px-3">Date</th>
              <th class="pb-3 pt-3 px-3">Item UID</th>
              <th class="pb-3 pt-3 px-3">Part Number</th>
              <th class="pb-3 pt-3 px-3">Description</th>
              <th class="pb-3 pt-3 px-3">Quantity</th>
              <th class="pb-3 pt-3 px-3">Location</th>
              <th class="pb-3 pt-3 px-3">UoM</th>
              <th class="pb-3 pt-3 px-3">Picklist</th>
              <th class="pb-3 pt-3 px-3">Source</th>
              <th class="pb-3 pt-3 px-3" colspan="2">Received By</th>
            </tr>
            <tr v-for="item in today_receipts.data" :key="item.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <Link class="flex items-center px-3 py-2 focus:text-orange-500">
                  {{ item.date }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.item_name }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.part_no }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.description }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.quantity }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.location }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.unit_of_measure }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.pick_list_no }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.source }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.user }}
                </Link>
              </td>
              <td class="w-px border-t">
                <Link class="flex items-center px-3" tabindex="-1">
                  <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
                </Link>
              </td>
            </tr>
            <tr v-if="today_receipts.data.length === 0">
              <td class="px-2 py-2 border-t" colspan="11">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="today_receipts.links" />
      </div>
      <div id="tabs-summaryFill" class="tab-pane fade" role="tabpanel" aria-labelledby="tabs-summary-tabFill">
        <div class="flex items-center justify-between mb-6">
          <a
            v-if="summaries.data.length > 0"
            class="btn-orange px-3 py-2 text-xs cursor-pointer"
            :href="`/dispatches/receipts/summaries/download/${urlSummary()}`"
            download
            target="__blank"
          >
            <span>Download</span>
          </a>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-2 pt-2 px-3">Picking Date</th>
              <th class="pb-2 pt-2 px-3">Order Number</th>
              <th class="pb-2 pt-2 px-3">Customer</th>
              <th class="pb-2 pt-2 px-3">Part Number</th>
              <th class="pb-2 pt-2 px-3">Part Description</th>
              <th class="pb-2 pt-2 px-3">Quantity Ordered</th>
              <th class="pb-2 pt-2 px-3">Quantity Picked</th>
              <th class="pb-2 pt-2 px-3">Quantity Packed</th>
              <th class="pb-2 pt-2 px-3">UoM</th>
            </tr>
            <tr
              v-for="inventory in summaries.data"
              :key="inventory.id"
              class="hover:bg-orange-100 focus-within:bg-gray-100"
            >
              <td class="border-t">
                <span class="flex items-center px-3 py-2 focus:text-indigo-500">
                  {{ inventory.date }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2 focus:text-indigo-500">
                  {{ inventory.order_no }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2 focus:text-indigo-500">
                  {{ inventory.customer }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2 focus:text-indigo-500">
                  {{ inventory.sku_name }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2 focus:text-indigo-500">
                  {{ inventory.description }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center justify-center px-3 py-2 focus:text-indigo-500">
                  {{ inventory.quantity_ordered }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center justify-center px-3 py-2 focus:text-indigo-500">
                  {{ inventory.quantity_picked }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center justify-center px-3 py-2 focus:text-indigo-500">
                  {{ inventory.quantity_packed }}
                </span>
              </td>
              <td class="w-px border-t">
                <span class="flex items-center px-3 py-2 focus:text-indigo-500 text-right">
                  {{ inventory.unit_of_measure }}
                </span>
              </td>
            </tr>
            <tr v-if="summaries.data.length === 0">
              <td class="px-6 py-4 border-t" colspan="8">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="summaries.links" />
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import SearchFilter from '@/Shared/SearchFilter'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import DateRange from '@/Shared/DateRange'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Pagination from '@/Shared/Pagination'
import Multiselect from '@vueform/multiselect'
import Checkbox from '@/Shared/Checkbox'

export default {
  components: {
    Head,
    Icon,
    Link,
    SearchFilter,
    DateRange,
    TextInput,
    SelectInput,
    LoadingButton,
    Pagination,
    Multiselect,
    Checkbox,
  },
  layout: Layout,
  props: {
    filters: Object,
    today_receipts: Object,
    locations: Object,
    summaries: Object,
    active: Boolean,
    picklist: Object,
  },
  data() {
    return {
      cushion: false,
      form: this.$inertia.form({
        item_id: null,
        location_id: null,
        quantity: null,
        part_number: null,
        pick_list_id: this.picklist.id,
      }),
      search: {
        dateValue: this.filters.dateValue,
      },
      summary: {
        dateRange: this.filters.dateRange,
      },
      selectedLocation: null,
    }
  },
  computed: {
    role() {
      return this.$inertia.page.props.auth.user.role
    },
  },
  methods: {
    urlScans() {
      let query = ''
      if (this.search.dateValue) {
        query += `dateValue=${this.search.dateValue}`
      }
      if (this.picklist) {
        if (query) {
          query += '&'
        }
        query += `picklistId=${this.picklist.id}`
      }
      if (query) {
        query = `?${query}`
      }
      return query
    },
    urlSummary() {
      let query = ''
      if (this.summary.dateRange) {
        if (query) {
          query += '&'
        }
        query += `dateRange=${this.summary.dateRange}`
      }
      if (this.picklist) {
        if (query) {
          query += '&'
        }
        query += `picklistId=${this.picklist.id}`
      }
      if (query) {
        query = `?${query}`
      }
      return query
    },
    store() {
      this.form.transform(({...data }) => ({
        has_cushion: this.cushion,
        ...data,
      }))
      this.form.post('/dispatches', {
        onSuccess: () => {
          this.form.reset(
            'item_id',
            'quantity',
            'part_number',
          )
        },
      })
    },
    onSelectedLocation(location, id) {
      this.form.location_id = location
      this.selectedLocation = location
      this.$inertia.get(`/dispatches/receive-picklist/${this.form.pick_list_id}`, {location}, {
        preserveState: true,
        preserveScroll: true,
        replace: true,
      })
    },
    onSearchLocationChange: throttle(function (location) {
      this.$inertia.get(`/dispatches/receive-picklist/${this.form.pick_list_id}`, {location: this.selectedLocation}, {
        preserveState: true,
        preserveScroll: true,
        replace: true,
      })
    }, 200),
  }
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
  .multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
  .multiselect-option.is-selected {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
</style>
